import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LinkedinAd = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14924)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#BFCDFF"
          />
          <rect
            x="59.75"
            y="22.75"
            width="41.5"
            height="67.5"
            rx="7.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="72.2305"
            y="27"
            width="17.641"
            height="2"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="74.75"
            y="38.75"
            width="90.5"
            height="79.5"
            rx="1.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="74"
            y="77"
            width="92"
            height="2"
            fill="#1E1E1E"
          />
          <rect
            x="74"
            y="46"
            width="92"
            height="1.5"
            fill="#1E1E1E"
          />
          <rect
            x="81"
            y="62"
            width="77"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="81"
            y="69"
            width="61"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="93"
            y="54"
            width="19"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <circle
            cx="85"
            cy="55"
            r="4"
            fill="#8C8C8C"
          />
          <circle
            cx="151.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="156.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="161.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="127"
            cy="90"
            r="3"
            fill="#0C5CEF"
          />
          <path
            d="M115.296 88.5799C115.396 88.4398 115.604 88.4398 115.704 88.5799L132.265 111.855C132.383 112.021 132.264 112.25 132.061 112.25H98.9388C98.7357 112.25 98.6174 112.021 98.7351 111.855L115.296 88.5799Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M129.797 96.5616C129.897 96.4234 130.103 96.4234 130.203 96.5616L141.247 111.854C141.366 112.019 141.248 112.25 141.044 112.25H118.956C118.752 112.25 118.634 112.019 118.753 111.854L129.797 96.5616Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M177.658 47.5H172.8V32.2339H177.658V47.5ZM187.743 36.7205C187.176 36.7205 186.632 36.9433 186.231 37.3399C185.83 37.7365 185.604 38.2744 185.604 38.8353V47.5H180.497V32.2339H185.604V33.8052C186.801 32.8032 188.314 32.2441 189.882 32.224C193.051 32.224 195.25 34.5464 195.25 38.9539V47.5H189.882V38.8353C189.884 38.5567 189.829 38.2807 189.722 38.023C189.616 37.7652 189.458 37.5309 189.259 37.3335C189.061 37.1361 188.824 36.9794 188.564 36.8725C188.304 36.7656 188.025 36.7106 187.743 36.7106V36.7205ZM177.748 27.4706C177.748 27.9592 177.601 28.4369 177.327 28.8432C177.052 29.2495 176.662 29.5661 176.205 29.7531C175.749 29.9401 175.246 29.989 174.761 29.8937C174.277 29.7984 173.831 29.5631 173.482 29.2176C173.132 28.872 172.894 28.4318 172.798 27.9526C172.702 27.4733 172.751 26.9766 172.94 26.5251C173.129 26.0737 173.45 25.6878 173.861 25.4164C174.272 25.1449 174.755 25 175.249 25C175.908 25.0052 176.539 25.2678 177.003 25.7306C177.467 26.1933 177.728 26.8188 177.728 27.4706H177.748Z"
            fill="#0A66C2"
            stroke="#0A66C2"
            strokeWidth="0.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14924">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
